// import AuthLayout from "../../components/";
import { Button, Col, Image, Layout, List, Row } from "antd";
import { FaCheckCircle } from "react-icons/fa";
import { useNavigate } from "react-router";
import { ImageUrl } from "../../helpers/Function";
// import router from "next/router";

function TimeManagement() {
  const navigate = useNavigate();

  const data1 = [
    {
      title: "Attach a logo to the portal.",
    },
    {
      title: "Create a referral code for users to self-enroll into a portal.",
    },
  ];

  return (
    <>
      <Layout style={{ minHeight: "100vh", backgroundSize: "cover" }}>
        <section className="bg-white top-bottom-padding two-colum-white">
          <Row justify={"center"}>
            <Col lg={19}>
              <Row justify={"center"} gutter={[32, 32]} className="gutter-0">
                <Col xs={24} sm={24} md={12}>
                  <div className="c-img">
                    <Image
                      preview={false}
                      alt={"Failed to load image"}
                      src={ImageUrl("c51.png")}
                    />
                  </div>
                </Col>
                <Col xs={24} md={12}>
                  <div className="">
                    <Image
                      preview={false}
                      alt={"Failed to load image"}
                      src={ImageUrl("miniImg4.png")}
                    />
                    <h4>
                    Green Cleaning Products and Practices: Promoting Healthier Indoor Environment
                    </h4>
                    <p className="text-p-16">Duration:2 Hours 30 Minutes</p>
                    

                    <h5 className="c-heading">Description</h5>

                    <p className="text-p-16">
                    The training program is dedicated to unraveling the world of green cleaning products and practices. This training is a champion for the health and safety of children, staff, and custodians, with a clear focus on ushering in positive changes. This enlightening journey takes participants from conventional cleaning products to the realm of Green Products and Green Cleaning Best Practices. The training equips attendees with insights into the science underpinning the transition, as well as the links between chemical toxins and childhood and staff illnesses.
                    </p>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </section>

       
      </Layout>
    </>
  );
}

export default TimeManagement;
